export default "__VITE_ASSET__C6ivC0Ny__";